export default "__VITE_ASSET__CHw_PZ9t__"